module.exports = __webpack_public_path__ + "static/img/testimony (22).627f6d75.jpg";